import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

@Directive({
  selector: '[CustomMonthDirective]',
  providers: [{provide: NG_VALIDATORS, useExisting: CustomMonthDirective, multi: true}]
})
export class CustomMonthDirective implements Validator {
  @Input()
  CustomMonthDirective:number;
  validate(c: FormControl): {[key: string]: any} {
      let v:number = c.value;
      return (v> 12 || v==0)? {"CustomMonthDirective": true} : null;
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Directives/CustomMonthDirective.ts